import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { JobseekerService } from 'src/app/jobseeker/shared/services/jobseeker.service';
import { mergeMap, catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import * as SpecializationActions from './actions';

@Injectable()
export class SpecializationEffects{

        // Specialization
        loadSpecializationList$ = createEffect(() => this.actions$.pipe(
            ofType(SpecializationActions.getJobseekerSpecializationList),
            mergeMap(() => this.jobseekerService.getSpecializationList()
            .pipe(
                map(response => {
                    const specializations = response.data
                    specializations.forEach(specialization => {
                        specialization.isHead = specialization.id == specialization.head.id;
                        specialization.specializationId = specialization.id;
                        specialization.headSpecializationId = specialization.head.id;
                        specialization.childSpecializationIds = specializations.filter(cc => cc.head.specializationId == specialization.id && cc.id != specialization.id).map(cc => cc.id);
                    })
                    return SpecializationActions.getJobseekerSpecializationListSuccess({payload: specializations})}
                ),
                catchError(response => of(SpecializationActions.getJobseekerSpecializationListFail({payload: response.error})))
            ))
        ));


    constructor(private actions$: Actions, private jobseekerService: JobseekerService){}
}